import { render, staticRenderFns } from "./DonutChart08.vue?vue&type=template&id=767f65cd&scoped=true"
import script from "./DonutChart08.vue?vue&type=script&lang=js"
export * from "./DonutChart08.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767f65cd",
  null
  
)

export default component.exports